module.exports = __webpack_public_path__ + "a0b9dfee834564ab168855e391c5c288.svg";